import React from 'react';
import { Box, Toolbar } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Outlet } from 'react-router-dom';
import Sidebar from './sidebar';

// Keep this in sync with the drawer width used by Sidebar
const drawerWidth = 220;

function MasterDataLayout() {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	return (
		<Box sx={{ display: 'flex', minHeight: '100vh'}}>
			{/* Left sidebar (permanent on desktop, temporary on mobile) */}
			<Sidebar />

			{/* Content area takes remaining space */}
			<Box
				component="main"
				sx={{
					flexGrow: 1,
					width: '100%',
					bgcolor: '#eef5ff',
					ml: { xs: 0, md: `${drawerWidth}px` },
					p: { xs: 2, md: 3 },
				}}
			>
				{/* Offset for mobile top AppBar rendered by Sidebar */}
				{isMobile && <Toolbar variant="dense" sx={{ minHeight: 56 }} />}

				{/* Child routes render here */}
				<Outlet />
			</Box>
		</Box>
	);
}

export default MasterDataLayout;

